<div class="chip mr-2">
    <div class="chip-close">
        <i class="fas fa-times ml-2 .chip-icon" (click)="closeChip(value)"></i>
    </div>
    <div class="chip-content">
        <strong class="text-chip">{{ textChip }}</strong>
    </div>
</div>
